<template>
  <v-app>
    <v-app-bar app dark>
      <div class="d-flex align-center">op-dev</div>
      <v-spacer />
      <v-btn href="https://dashboard.op-dev.io" text>Sign in</v-btn>
    </v-app-bar>

    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>

<script>
export default {
  name: 'App',

  components: {
  },

  data: () => ({
    //
  }),
};
</script>
